module.exports = __webpack_public_path__ + "static/NudistaSemiBold-Italic-2a2631946d90eca030aa3e8d8b72ddeb.ttf";